// extracted by mini-css-extract-plugin
export default {"container":"BaseJobCandidatesScreen_container__Zzalp","header":"BaseJobCandidatesScreen_header__pA-aG","progress":"BaseJobCandidatesScreen_progress__PMp-6"};